import { Component, OnInit } from '@angular/core';
import { HttpService } from '../services/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { QuerystoreService } from '../services/querystore.service';
import { MerklisteService } from '../services/merkliste.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JsonExportService } from '../services/json-export.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';



@Component({
  selector: 'app-document-view',
  templateUrl: './document-view.component.html',
  styleUrls: ['./document-view.component.scss']
})
export class DocumentViewComponent implements OnInit {
  private _jsonURL27 = environment.elastic_url_json + 'dhip_Mapping_doctyp27.json';
  private _jsonURL28 = environment.elastic_url_json + 'dhip_Mapping_doctyp28.json';

  selectedIndex: any;
  hits: string[];

  copy: any;
  elementHtml: string;

  sammlung = [];

  urheberfilter: string[];
  message: any;

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  queryNav = [];
  QueryName: any;
  QueryID: any;
  QueryFotos: any;

  license: string;
  checked: boolean;

  placesVerortung = [];
  placesStandort_aktuell = [];
  placesKirchenkreis = [];
  placesStandort_ehem = [];

  prevItem: string;
  nextItem: string;
  imgTitle: string;

  sourcenames27 = [
    {
      sourceName: '27_attachment0',
      anhangTitel: '27_anhang_datei0'
    },
    {
      sourceName: '27_attachment1',
      anhangTitel: '27_anhang_datei1'
    },
    {
      sourceName: '27_attachment2',
      anhangTitel: '27_anhang_datei2'
    },
    {
      sourceName: '27_attachment3',
      anhangTitel: '27_anhang_datei3'
    },
    {
      sourceName: '27_attachment4',
      anhangTitel: '27_anhang_datei4'
    },
    {
      sourceName: '27_attachment5',
      anhangTitel: '27_anhang_datei5'
    },
    {
      sourceName: '27_attachment6',
      anhangTitel: '27_anhang_datei6'
    },
    {
      sourceName: '27_attachment7',
      anhangTitel: '27_anhang_datei7'
    },
    {
      sourceName: '27_attachment8',
      anhangTitel: '27_anhang_datei8'
    },
    {
      sourceName: '27_attachment9',
      anhangTitel: '27_anhang_datei9'
    },
    {
      sourceName: '27_attachment10',
      anhangTitel: '27_anhang_datei10'
    },
    {
      sourceName: '27_attachment11',
      anhangTitel: '27_anhang_datei11'
    },
    {
      sourceName: '27_attachment12',
      anhangTitel: '27_anhang_datei12'
    }
  ];

  sourcenames28 = [
    {
      sourceName: '28_attachment0',
      anhangTitel: '28_anhang_datei0'
    },
    {
      sourceName: '28_attachment1',
      anhangTitel: '28_anhang_datei1'
    },
    {
      sourceName: '28_attachment2',
      anhangTitel: '28_anhang_datei2'
    },
    {
      sourceName: '28_attachment3',
      anhangTitel: '28_anhang_datei3'
    },
    {
      sourceName: '28_attachment4',
      anhangTitel: '28_anhang_datei4'
    },
    {
      sourceName: '28_attachment5',
      anhangTitel: '28_anhang_datei5'
    },
    {
      sourceName: '28_attachment6',
      anhangTitel: '28_anhang_datei6'
    },
    {
      sourceName: '28_attachment7',
      anhangTitel: '28_anhang_datei7'
    },
    {
      sourceName: '28_attachment8',
      anhangTitel: '28_anhang_datei8'
    },
    {
      sourceName: '28_attachment9',
      anhangTitel: '28_anhang_datei9'
    },
    {
      sourceName: '28_attachment10',
      anhangTitel: '28_anhang_datei10'
    },
    {
      sourceName: '28_attachment11',
      anhangTitel: '28_anhang_datei11'
    },
    {
      sourceName: '28_attachment12',
      anhangTitel: '28_anhang_datei12'
    },
    {
      sourceName: '28_attachment13',
      anhangTitel: '28_anhang_datei13'
    },
    {
      sourceName: '28_attachment14',
      anhangTitel: '28_anhang_datei14'
    },
    {
      sourceName: '28_attachment15',
      anhangTitel: '28_anhang_datei15'
    },
    {
      sourceName: '28_attachment16',
      anhangTitel: '28_anhang_datei16'
    },
    {
      sourceName: '28_attachment17',
      anhangTitel: '28_anhang_datei17'
    },
    {
      sourceName: '28_attachment18',
      anhangTitel: '28_anhang_datei18'
    },
    {
      sourceName: '28_attachment19',
      anhangTitel: '28_anhang_datei19'
    },
  ];

  document: any[];
  jsonData: any[];
  lang: any;
  mapping: any;

  constructor(
    private http: HttpService,
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private hitsStore: QuerystoreService,
    private merklisteService: MerklisteService,
    public snackBar: MatSnackBar,
    public jsonExport: JsonExportService,
  ) {
    this.merklisteService.MessageCount$.subscribe((merklisteCount: number) => {
      this.checked = this.merklisteService.hasId(this.route.snapshot.paramMap.get('id'));
    });

  }


  ngOnInit() {

    this.http.getLanguage().subscribe( res => {
      console.log(res);
      this.lang = res;
    });




    this.checked = this.merklisteService.hasId(this.route.snapshot.paramMap.get('id'));
    this.http.currentMessage.subscribe(message => this.message = message);
    const id = this.route.snapshot.paramMap.get('id');

    this.http.documentBy27(id).subscribe(res27 => {
      if (res27.found === true) {
        console.log(res27);
        this.document = res27;
        this.jsonData = this.document['_source'];
        if (this.document['_source']) {
          if (this.document['_type'] === 'doctyp27') {

            for (let item of this.sourcenames27) {
              if (this.document['_source'][item.sourceName]) {
                if (this.document['_source'][item.anhangTitel]) {
                  this.imgTitle = this.document['_source'][item.anhangTitel];
                } else {
                  this.imgTitle = this.document['_source'][item.sourceName];
                }
                this.galleryImages.push(
                  {
                    small: '/wp-content/themes/pukeko-child/app/assets/vimg/' + this.document['_source'][item.sourceName],
                    medium: '/wp-content/themes/pukeko-child/app/assets/vimg/' + this.document['_source'][item.sourceName],
                    big: '/wp-content/themes/pukeko-child/app/assets/vimg/' + this.document['_source'][item.sourceName],
                    description: this.imgTitle
                  },
                );
              }
            }

          }
        }
      }
    }, err => { console.log(err); });

    this.http.documentBy28(id).subscribe(res28 => {
      console.log(res28);

      if (res28.found === true) {
        console.log(res28);
        this.document = res28;
        this.jsonData = this.document['_source'];
        if (this.document['_source']) {
          if (this.document['_type'] === 'doctyp28') {
            for (let item of this.sourcenames28) {
              if (this.document['_source'][item.sourceName]) {
                if (this.document['_source'][item.anhangTitel]) {
                  this.imgTitle = this.document['_source'][item.anhangTitel];
                } else {
                  this.imgTitle = this.document['_source'][item.sourceName];
                }
                this.galleryImages.push(
                  {
                    small: '/wp-content/themes/pukeko-child/app/assets/vimg/' + this.document['_source'][item.sourceName],
                    medium: '/wp-content/themes/pukeko-child/app/assets/vimg/' + this.document['_source'][item.sourceName],
                    big: '/wp-content/themes/pukeko-child/app/assets/vimg/' + this.document['_source'][item.sourceName],
                    description: this.imgTitle,
                  },
                );
              }
            }
          }
        }
      }
    }, err => { console.log(err); });

    this.hits = this.hitsStore.getAllHits();

    if (this.hits) {
      for (let i = 0; i < this.hits.length; i++) {
        if (this.hits[i] === id) {
          this.nextItem = this.hits[i + 1];
          this.prevItem = this.hits[i - 1];
        }
      }
    }

    this.galleryOptions = [
      {
        width: '100%',
        previewDescription: true,
        imageDescription: true,
        thumbnailsPercent: 15,
        height: 'calc(100vh - 64px)',
        thumbnailsColumns: 8,
        // arrowPrevIcon: 'prev-slide',
        // arrowNextIcon: 'next-slide',
        imageAnimation: NgxGalleryAnimation.Slide,
        thumbnails: true,
      },
      // max-width 769
      {
        breakpoint: 769,
        width: '100%',
        height: 'calc(100vh - 117px);',
        imagePercent: 80,
        thumbnailsColumns: 6,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20,
        thumbnails: false,
      },
      // max-width 400
      {
        thumbnailsColumns: 2,
        breakpoint: 400,
        preview: false,
        thumbnails: false,
      }
    ];

    this.galleryImages = [];






  }

  toDocument(id) {
    // window.open('/#/document/' + id, "_self" );
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + id]));
  }

  prev() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + this.prevItem]));
  }

  next() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + this.nextItem]));
  }

  public onMerklistToggle(event: any, document: any) {
    console.log(document);
    const snackBarMessage: string = (event.checked) ?
      'Zur Merkliste hinzugefügt' : 'Von Merkliste entfernt';
    this.snackBar.open(snackBarMessage, '', {
      duration: 1000
    });
    if (event.checked) {
      this.merklisteService.registerItem(document);
    } else {
      this.merklisteService.unregisterItem(document);
    }
  }




  printDoc() {
    window.print();
  }


  public getMapping(): Observable<any> {
    if (this.document['_type'] === 'doctyp27') {
      return this.httpClient.get(this._jsonURL27);
    }
    if (this.document['_type'] === 'doctyp28') {
      return this.httpClient.get(this._jsonURL28);
    }
   
  }

  download() {
    this.getMapping().subscribe(data => {
      console.log(data);
      this.mapping = data;
      console.log(this.mapping);
        this.jsonExport.json2output(this.document, this.mapping, this.lang);
    });
    
   
    
  }





}



